<router-outlet></router-outlet>

<!-- Loader -->
<wz-loader></wz-loader>
